import { StoryblokComponent } from '@storyblok/react';

import { JsonObject } from '../../../types/jsonObject';
import { ServiceOSApiClient } from '../../../utils/serviceOSApiClient';
import { FormBuilderRequestLifecycleContext } from '../../FormBuilder/FormBuilder.types';
import { ProLoginFormProps } from './ProLoginForm.types';

const serviceOSApiClient = new ServiceOSApiClient();

export const ProLoginForm = (props: ProLoginFormProps) => {
  const { blok } = props;
  const { form } = blok;

  if (!form.length) {
    return null;
  }

  const loginRequest = async (data: JsonObject, context: FormBuilderRequestLifecycleContext) => {
    const { successMessage, errorMessage } = await serviceOSApiClient.login(
      data.username as string,
      data.password as string
    );

    if (errorMessage) {
      context.setErrorMessage(errorMessage);
      return false;
    }

    if (successMessage) {
      context.setSuccessMessage(successMessage);
      return true;
    }
  };

  const fountainUrlRequest = async (context: FormBuilderRequestLifecycleContext) => {
    const { data, errorMessage } = await serviceOSApiClient.generateFountainLink();

    if (errorMessage) {
      context.setErrorMessage(errorMessage);
      return;
    }

    const portalUrl = data?.portal_url || null;

    if (typeof window !== 'undefined' && portalUrl) {
      window.location = portalUrl;
    }
  };

  const handleSubmit = async (data: JsonObject, context: FormBuilderRequestLifecycleContext) => {
    const loggedIn = await loginRequest(data, context);

    if (loggedIn) {
      await fountainUrlRequest(context);
    }
  };

  const formBuilderBlok = {
    ...form[0],
    submitDataAs: 'json',
  };

  return (
    <StoryblokComponent blok={formBuilderBlok} key={formBuilderBlok._uid} onSubmit={handleSubmit} />
  );
};
